export interface IRendition {
    readonly name: string;
    readonly items: ReadonlyArray<IRenditionItem>;
}

export interface IRenditionItem {
    readonly href: URI | string;
}

export class Rendition implements IRendition {
    name: string;
    readonly items: ReadonlyArray<IRenditionItem>;

    private constructor(name: string, items: Array<IRenditionItem>) {
        this.name = name;
        this.items = items;
    }

    static createRendition(name: string, items: Array<IRenditionItem>): Rendition {
        return new Rendition(name, items);
    }
}
